"use client";

import { useTranslations as useTranslationsNextIntl } from "next-intl";
import type { Namespace } from "./constants";

export function useTranslations<N extends Namespace>(namespace: N) {
  const t = useTranslationsNextIntl(namespace);
  return t;
}

export type ClientUseTranslations = ReturnType<typeof useTranslations>;
